import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video"]

  connect() {
    // Track video view on page load
    this.trackView()
  }

  trackPlay() {
    // Analytics: video played
    this.sendEvent('professor_mode_video_played')
  }

  trackComplete() {
    // Analytics: video watched to end
    this.sendEvent('professor_mode_video_completed')
  }

  trackView() {
    // Analytics: page viewed
    this.sendEvent('professor_mode_page_viewed')
  }

  sendEvent(eventName) {
    const csrfToken = document.querySelector('[name="csrf-token"]')?.content

    if (!csrfToken) {
      console.warn('CSRF token not found, skipping analytics event')
      return
    }

    fetch('/events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        event: eventName
      })
    }).catch(error => {
      console.error('Error tracking event:', error)
    })
  }
}
